import OrderFlowDeliveryPage from '../pages/flow/OrderFlowDeliveryPage'
import OrderFlowKitchenPage from '../pages/flow/OrderFlowKitchenPage'
import OrderFlowOvenPage from '../pages/flow/OrderFlowOvenPage'
import OrderFlowPage from '../pages/flow/OrderFlowPage'
import OrderFlowSalonPage from '../pages/flow/OrderFlowSalonPage'
import OrderFlowWaiterPage from '../pages/flow/OrderFlowWaiterPage'
import OrderFlowAllPage from '../pages/flow/OrderFlowAllPage'


const routes = [
    {
        name: 'OrderFlowAllPage',
        path: '/flow/all',
        component: OrderFlowAllPage,
        permission: "ORDER_SHOW_BAR",
        meta: {
            disableFooter: true
        }
    },
    {
        name: 'OrderFlowPage',
        path: '/flow/bar',
        component: OrderFlowPage,
        permission: "ORDER_SHOW_BAR",
        meta: {
            disableFooter: true
        }
    },
    {
        name: 'OrderFlowKitchenPage',
        path: '/flow/kitchen',
        component: OrderFlowKitchenPage,
        permission: "ORDER_SHOW_KITCHEN",
        meta: {
            disableFooter: true
        }
    },
    {
        name: 'OrderFlowOvenPage',
        path: '/flow/oven',
        component: OrderFlowOvenPage,
        permission: "ORDER_SHOW_OVEN",
        meta: {
            disableFooter: true
        }
    },
    {
        name: 'OrderFlowDeliveryPage',
        path: '/flow/delivery',
        component: OrderFlowDeliveryPage,
        permission: "ORDER_SHOW_DELIVERY",
        meta: {
            disableFooter: true
        }
    },
    {
        name: 'OrderFlowSalonPage',
        path: '/flow/salon',
        component: OrderFlowSalonPage,
        permission: "ORDER_SHOW_SALON", // TODO Hacer el permiso para salon
        meta: {
            disableFooter: true
        }
    },
    {
        name: 'OrderFlowWaiterPage',
        path: '/flow/waiter',
        component: OrderFlowWaiterPage,
        permission: "ORDER_SHOW_WAITER", // TODO Hacer el permiso para salon
        meta: {
            disableFooter: true
        }
    }

]

export default routes;
